import { Component, Prop, Vue } from "vue-property-decorator";
import { store } from "@/main";
import * as ins_media_types from "@/store/constants/ins_media_types";
import * as ins_user_info_types from "@/store/constants/ins_user_info_types";
import ImgFetched from "@/components/ImgFetched/ImgFetched.vue";
@Component({
  components: {
    ImgFetched
  }
})
class ConfirmOrderHeader extends Vue {
  @Prop()
  private ctx: any;
  @Prop()
  private offer: any;

  private imgStyle = "width:100%;height:100%;object-fit:cover;";
  private imgFollowStyle = this.imgStyle + "border-radius:50%;";
  private imgLikeStyle = this.imgStyle + "border-radius:8px;";
  private divStyle =
    "width:68px;height:68px;box-sizing:content-box;background:rgb(233,236,240);padding:16px;margin:0 auto;";
  private followStyle = this.divStyle + "border-radius:50%;";
  private postStyle = this.divStyle + "border-radius:24px;";

  get isFollow() {
    return this.offer.kind.includes("follow");
  }
  public render() {
    return (
      <div style={this.isFollow ? this.followStyle : this.postStyle}>
        <img-fetched
          style={this.isFollow ? this.imgFollowStyle : this.imgLikeStyle}
          src={this.getCurrentPost()}
          alt=""
          imgKind="user"
        />
      </div>
    );
  }
  private getCurrentPost() {
    const postInfo = store.getters[ins_media_types.GETTER_CURRENT_POST_INFO];
    const user_info = store.getters[ins_user_info_types.GETTER_CURRENT_INS_USER_INFO]
      ? store.getters[ins_user_info_types.GETTER_CURRENT_INS_USER_INFO].ins_user_info
      : null;
    return this.offer.kind.includes("follow")
      ? user_info.profile_pic_url
      : postInfo.display_url;
  }
}

export default ConfirmOrderHeader;
